import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Col } from 'react-grid-system'
import cs from 'classnames'

import AleloLogoBranco from 'assets/svg/alelo-logo-branco.svg'
import AleloLogo from 'assets/svg/alelo-logo.png'

import { useMobile } from '../../utils/mobile'
import { useScrolling } from '../../utils/scrolling'

import './Header.scss'

const Header = (props) => {
    const isMobile = useMobile()
    const isScroll = useScrolling()
    const scrollLogo =
        !isMobile && isScroll ? 'header__logo scroll' : 'header__logo'
    const scrollTitle =
        !isMobile && isScroll ? 'header__title scroll' : 'header__title'

    return (
        <div className={cs('header', props.styleGreen ? `green` : null)}>
            <Container className="header__container">
                <Col className="header__wrap" sm={12}>
                    <Link
                        to="/"
                        style={{ zIndex: '0' }}
                        data-gtm-event-category="alelo:loja-virtual"
                        data-gtm-event-action="clique:header"
                        data-gtm-event-label="logo"
                    >
                        <img
                            id="logoHeader"
                            className={scrollLogo}
                            src={props.styleGreen ? AleloLogoBranco : AleloLogo}
                            alt="Logotipo Alelo"
                        />
                    </Link>
                    {isMobile && props.styleGreen ? null : (
                        <span className={scrollTitle}>
                            <span>
                                Alelo <br /> <strong>Loja Virtual</strong>
                            </span>
                        </span>
                    )}
                    <div className="header__right">{props.children}</div>
                </Col>
            </Container>
        </div>
    )
}

export default Header
